import React from 'react';
import mocidadeImg from '../style/images/Mocidade_2025.png';

export default function Convite() {
    return (
        <section id="convite" className="theme-bg-dark margin-top-10">
            <div className="theme-bg-shapes-right"></div>
            <div className="theme-bg-shapes-left"></div>
            <div className="container-fluid">
                <div className="margin-bottom-10 margin-top-10">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="titulo-Convite animated wow fadeInUp animation-delay-1">MOCIDADE ESPÍRITA</div>
                            <div className="subtitulo-Convite animated wow fadeInUp animation-delay-3">Venha participar conosco dessa jornada de aprendizado e crescimento</div>
                            <div className="text-Convite animated wow fadeInUp animation-delay-5">Aulas aos sábados em nossa casa</div>
                            <div className="text-Convite animated wow fadeInUp animation-delay-7">Início das aulas 02/08/2025</div>
                            <div className="text-Convite animated wow fadeInUp animation-delay-7">Horário do encontro das 11:15 às 13:00</div>
                            <div className="text-Convite animated wow fadeInUp animation-delay-7 text-negrito-Convite">Entre 13 e 18 anos</div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <img className="mocidadeImg animated wow slideInRight animation-delay-1" alt="Mocidade" src={mocidadeImg} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}